// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    margin: 0;
}

.row{
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    width: 500px;
}

button{
    width: 50px;
    height: 50px;
}

.board-container{
    display: flex;
    height: 100vh;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction:column;
}

.board{
    margin-bottom: 10px;
}

.potential-endcoord{
    background-color: green;
}

.start-coord, .occupied{
    background-color: grey;
}

.hit{
    background-color: red;
}

.miss{
    background-color: black;
}

.black-screen{
    background-color: black;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.victory-screen{
    background-color: yellow;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.turn{
    color: white;
}

.victor{
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["body{\n    margin: 0;\n}\n\n.row{\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    width: 500px;\n}\n\nbutton{\n    width: 50px;\n    height: 50px;\n}\n\n.board-container{\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    flex-direction:column;\n}\n\n.board{\n    margin-bottom: 10px;\n}\n\n.potential-endcoord{\n    background-color: green;\n}\n\n.start-coord, .occupied{\n    background-color: grey;\n}\n\n.hit{\n    background-color: red;\n}\n\n.miss{\n    background-color: black;\n}\n\n.black-screen{\n    background-color: black;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.victory-screen{\n    background-color: yellow;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.turn{\n    color: white;\n}\n\n.victor{\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
